if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoplayTimer = null;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.length > 1;
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval || '5000', 10);
      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.restartAutoplay();
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.restartAutoplay();
        });
      }

      if ( this.slider ) {
        this.slider.addEventListener('keydown', (e)=>{
          if ( e.key === 'ArrowRight' || e.keyCode === 39 ) {
            e.preventDefault();
            this.changeSlide('next');
            this.restartAutoplay();
          } else if ( e.key === 'ArrowLeft' || e.keyCode === 37 ) {
            e.preventDefault();
            this.changeSlide('prev');
            this.restartAutoplay();
          }
        });
      }

      if ( this.autoplayEnabled ) {
        this.startAutoplay();

        if ( this.pauseOnHover ) {
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }

        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }

    }

    onVisibilityChange = () => {
      if ( document.hidden ) {
        this.stopAutoplay();
      } else if ( this.autoplayEnabled ) {
        this.startAutoplay();
      }
    }

    changeSlide(direction) {
      if ( ! this.length ) return;

      let nextIndex = this.index;

      if ( direction == 'next' ) {
        nextIndex = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        nextIndex = (this.index - 1 + this.length) % this.length;
      }

      this.goTo(nextIndex);
    }

    goTo(nextIndex) {
      if ( ! this.content[nextIndex] ) return;

      const previousIndex = this.index;
      this.index = nextIndex;

      if ( this.nextButton ) {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      }
      if ( this.prevButton ) {
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
      }

      // Instant jump when wrapping, to avoid scrolling through middle slides
      const wrapping = (
        (previousIndex === this.length - 1 && this.index === 0) ||
        (previousIndex === 0 && this.index === this.length - 1)
      );

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: wrapping ? 'auto' : 'smooth'
      });
    }

    startAutoplay() {
      if ( ! this.autoplayEnabled || this.length < 2 ) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.changeSlide('next');
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      if ( this.autoplayTimer ) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      if ( this.autoplayEnabled ) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}
